package org.example.project.screens_sys

import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.manager.SystemNodeError
import org.example.project.manager.SystemNodeInfo

object NodeUebersichtApi {
    private const val API = "nodeuebersicht"

    private val json = Json {
        ignoreUnknownKeys = true
        encodeDefaults = false
    }

    suspend fun loadNodes(): List<SystemNodeInfo> =
        runCatching {
            json.decodeFromString(ListSerializer(SystemNodeInfo.serializer()), LumaticaApiManager.call("$API/nodes"))
        }.getOrDefault(emptyList())

    suspend fun loadNodeErrors(nodeId: String, limit: Int = 100): List<SystemNodeError> =
        runCatching {
            json.decodeFromString(
                ListSerializer(SystemNodeError.serializer()),
                LumaticaApiManager.call("$API/node-errors/${apiPart(nodeId)}/${apiPart(limit.toString())}")
            )
        }.getOrDefault(emptyList())

    suspend fun triggerNodeAction(nodeId: String, action: String): Boolean =
        LumaticaApiManager.call("$API/node-action/${apiPart(nodeId)}/${apiPart(action)}").contains("\"ok\":true")

    private fun apiPart(value: String): String =
        js("encodeURIComponent")(if (value.isBlank()) "~" else value) as String
}
